import { EquipmentInventory } from "../../../../features/FloorManager/typings/svg.types";
import { EquipmentRowValues } from "../typings/equipment-row.types";

/**
 * takes row data and assembles a partial equipment inventory object
 */
export function mapUpdatedRowToPartialEquipmentInventory(
  values: EquipmentRowValues
): Partial<EquipmentInventory> {
  return {
    uid: values.uid,
    // status: values.status,
    picturePath: values.picturePath,
    name: values.name,
    equipmentCategoryId: values["equipmentCategory.id"],
    equipmentCategory: {
      id: values["equipmentCategory.id"],
      name: values["equipmentCategory.name"] ?? undefined
    },
    locationName: values.locationName ?? "",
    location: {
      id: values["location.id"],
      name: values["location.name"]
    },
    floorName: values.floorName ?? "",
    floor: {
      id: values["floor.id"],
      name: values["floor.name"]
    },
    description: values["description"],
    zoneInventoryId: values.zoneInventoryId ? Number(values.zoneInventoryId) : null,
    placeInventoryId: values.placeInventoryId ? Number(values.placeInventoryId) : null,
    assetRefId: values.assetRefId ?? "",
    pricePerHour: values.pricePerHour,
    bookable: values.bookable,
    bookingLeadTime:
      values.bookingLeadTime === null ||
      values.bookingLeadTime === undefined ||
      values.bookingLeadTime === ""
        ? null
        : Number(values.bookingLeadTime),
    servicePermissions: values.servicePermissions,
    depreciationDate: values.depreciationDate
  };
}
